"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function SuccessIcon(props) {
    return (react_1.default.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em", className: "t-icon t-icon-success ".concat(props.theme, "-theme") },
        react_1.default.createElement("path", { fill: "currentColor", d: "M4.07 11.41l-1.29 1.35 6.13 6.5 13-12.85-1.37-1.4-11.72 10.1-4.75-3.7z", fillRule: "evenodd", clipRule: "evenodd" })));
}
exports.default = SuccessIcon;
//# sourceMappingURL=SuccessIcon.js.map